import React from 'react';
import { InfoBox, InfoBoxVariant } from '@secretescapes/falcon';

export const title = 'No facilities are loaded for this property';
const subtitle = `Please go to the <a href="https://partners.secretescapes.com" target="_blank">Partner Portal</a> to add
          facilities. The sale cannot go live without them.`;

export const FacilitiesWarning = () => {
  return (
    <InfoBox
      dataAttributes={{ testid: 'facilities-warning' }}
      title={title}
      subTitle={subtitle}
      variant={InfoBoxVariant.urgency}
    />
  );
};
